<template>
  <div class="negocio__velo negocio__velo--encima" @click.self="$emit('cerrar')">
    <div class="negocio__modal planilla">
      <header class="planilla__cabecera">
        <div>
          <h2>📋 Planilla Maestra de Documentos {{ editable ? 'UDN' : '' }}</h2>
          <p>{{ subtitulo }}</p>
        </div>
        <button class="negocio__cerrar" type="button" @click="$emit('cerrar')">&times;</button>
      </header>

      <div class="planilla__barra">
        <div class="planilla__pestanas">
          <button
            v-for="p in pestanas"
            :key="p.id"
            type="button"
            :class="{ 'planilla__pestana--activa': area === p.id }"
            @click="area = p.id"
          >{{ p.nombre }} ({{ p.cuenta }})</button>
        </div>
        <div class="planilla__filtros">
          <select v-if="editable" v-model="estado">
            <option value="todos">Todos los estados</option>
            <option value="pendientes">Pendientes</option>
            <option value="validados">Validados</option>
          </select>
          <div class="negocio__buscar">
            <i class="mdi mdi-magnify"></i>
            <input v-model="q" type="search" placeholder="Filtrar Datos...">
          </div>
        </div>
      </div>

      <p v-if="error" class="negocio__aviso negocio__aviso--error">{{ error }}</p>

      <div class="planilla__cuerpo">
        <table class="planilla__tabla">
          <thead v-if="editable">
            <tr>
              <th>Documento</th>
              <th>Fecha Solicitud</th>
              <th class="negocio__centro">Documento en trámite</th>
              <th>Documento Virtual</th>
              <th class="negocio__centro">Documento Físico</th>
              <th class="negocio__centro">Acciones</th>
            </tr>
          </thead>
          <thead v-else>
            <tr><th>Documento</th><th>Etapa</th><th>Plazo</th><th class="negocio__centro">Obligatorio</th></tr>
          </thead>
          <tbody>
            <tr v-if="!filas.length">
              <td :colspan="editable ? 6 : 4" class="negocio__centro negocio__tenue">No se encontraron documentos con el criterio ingresado.</td>
            </tr>
            <tr v-for="d in filas" :key="d.id">
              <td>
                <div class="planilla__documento" :title="d.descripcion">
                  <span class="planilla__area" :class="`planilla__area--${d.area}`">{{ d.area.slice(0, 3) }}</span>
                  <strong>{{ d.nombre }}</strong>
                </div>
                <input
                  v-if="editable"
                  class="planilla__texto"
                  :value="d.referencia"
                  placeholder="Referencia (rol, caducidad…)"
                  :disabled="ocupado"
                  @change="editar(d, { referencia: $event.target.value })"
                >
              </td>

              <template v-if="editable">
                <td class="planilla__fecha">
                  <campo-fecha
                    :model-value="d.fecha_solicitud || ''"
                    placeholder="—"
                    @update:model-value="(v) => editar(d, { fecha_solicitud: v || null })"
                  />
                </td>
                <td class="negocio__centro">
                  <button
                    type="button"
                    class="planilla__marca"
                    :class="{ 'planilla__marca--tramite': d.en_tramite }"
                    :disabled="ocupado"
                    :title="d.en_tramite ? 'Quitar de en trámite' : 'Marcar en trámite'"
                    @click="editar(d, { en_tramite: !d.en_tramite })"
                  >{{ d.en_tramite ? '⏳ En trámite' : '—' }}</button>
                </td>
                <td>
                  <div v-if="d.url" class="planilla__virtual">
                    <span class="planilla__cargado" :title="d.nombre_archivo">{{ d.referencia || d.nombre_archivo || d.nombre }}</span>
                    <a class="planilla__ver" :href="d.url" target="_blank" rel="noopener" title="Ver documento">👁️</a>
                    <a class="planilla__bajar" :href="d.url" :download="d.nombre_archivo || ''" title="Descargar">📥</a>
                  </div>
                  <span v-else class="negocio__tenue">No cargado</span>
                </td>
                <td class="negocio__centro">
                  <button
                    type="button"
                    class="planilla__fisico"
                    :class="{ 'planilla__fisico--si': d.fisico }"
                    :disabled="ocupado"
                    :title="d.fisico ? 'El original está en la oficina' : 'Sin original en la oficina'"
                    @click="editar(d, { fisico: !d.fisico })"
                  >{{ d.fisico ? '✓' : '✕' }}</button>
                  <input
                    v-if="d.fisico"
                    class="planilla__texto planilla__texto--carpeta"
                    :value="d.carpeta"
                    placeholder="Carpeta"
                    :disabled="ocupado"
                    @change="editar(d, { carpeta: $event.target.value })"
                  >
                </td>
                <td class="negocio__centro">
                  <label v-if="!d.subido" class="planilla__subir">
                    📤 Subir
                    <input type="file" :disabled="ocupado" @change="subir(d, $event)">
                  </label>
                  <span v-else class="negocio__badge negocio__badge--ok">✓ Validado</span>
                </td>
              </template>

              <template v-else>
                <td>{{ d.fase.numero ? `${d.fase.numero}: ` : '' }}{{ d.fase.nombre }}</td>
                <td>{{ d.plazo_dias }} día{{ d.plazo_dias === 1 ? '' : 's' }}</td>
                <td class="negocio__centro">{{ d.obligatorio ? '✓' : '—' }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="planilla__pie">
        <span>{{ editable ? 'Planilla sincronizada con el expediente de la unidad de negocio' : 'Catálogo de documentos de la industria. Para editar, ábrela desde la ficha de una unidad.' }}</span>
        <button class="negocio__boton planilla__cerrar" type="button" @click="$emit('cerrar')">Cerrar</button>
      </footer>
    </div>
  </div>
</template>

<script>
import CampoFecha from './CampoFecha.vue';

// La Planilla Master: editable para una unidad (desde su ficha) o catálogo de sólo
// lectura de la industria. Los cambios los guarda el tablero, que la recibe de vuelta.
export default {
  name: 'PlanillaMaster',

  components: { CampoFecha },

  props: {
    documentos: { type: Array, required: true },
    areas: { type: Array, required: true },
    editable: { type: Boolean, default: false },
    nombre: { type: String, default: '' },
    ocupado: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },

  emits: ['cerrar', 'editar', 'subir'],

  data() {
    return { area: 'todos', estado: 'todos', q: '' };
  },

  computed: {
    subtitulo() {
      const total = `${this.documentos.length} requerimientos (${this.areas.map((a) => a.nombre).join(', ')})`;
      return this.editable ? `${this.nombre} · ${total}` : `Matriz documental de la industria · ${total}`;
    },
    pestanas() {
      return [
        { id: 'todos', nombre: 'Todos', cuenta: this.documentos.length },
        ...this.areas.map((a) => ({
          id: a.id, nombre: a.nombre, cuenta: this.documentos.filter((d) => d.area === a.id).length,
        })),
      ];
    },
    filas() {
      const q = this.q.trim().toLowerCase();
      return this.documentos.filter((d) => (
        (this.area === 'todos' || d.area === this.area)
        && (this.estado === 'todos' || (this.estado === 'validados') === Boolean(d.subido))
        && (!q || [d.nombre, d.referencia, d.descripcion].some((t) => t && t.toLowerCase().includes(q)))
      ));
    },
  },

  methods: {
    editar(documento, campos) {
      this.$emit('editar', documento.id, campos);
    },

    subir(documento, evento) {
      const archivo = evento.target.files[0];
      evento.target.value = '';
      if (archivo) this.$emit('subir', documento.id, archivo);
    },
  },
};
</script>
